import { customerIdSelector } from "@/react/features/customer/customerSlice";
import { getEnv } from "@/env";

const baseUrl = getEnv("VUE_APP_API_V2_URL");

export const jobsBaseUrl = `${baseUrl}/v1/jobs`;

export const customerJobsUrl = (getState) =>
  `${jobsBaseUrl}/customers/${customerIdSelector(getState())}`;
